<template>
  <div class="content">
    <div class="card-box data-table">
      <div class="inp-list">
        <div class="item">
          <span class="label">{{ $t('g.operator') }}</span>
          <el-cascader size="small" style="width: 100%;flex: 1;" :clearable="true" v-model="formData.valCode"
            :props="formData.props" :options="render.cascade_options_direct" />
        </div>
        <div class="item">
          <span class="label">{{ $t('expenses.type') }}</span>
          <el-select class="inp" size="small" v-model="formData.valTimeType" :placeholder="$t('g.choose')">
            <el-option v-for="item in render.types" :key="item.value" :label="item.label" :value="item.value">
            </el-option>
          </el-select>
        </div>
        <div class="item">
          <span class="label">{{ $t("g.create_at") }}</span>
          <el-date-picker v-model="formData.valTime"
            :value-format="formData.valTimeType == 1 ? 'YYYY-MM' : 'YYYY-MM-DD'" size="small"
            :type="formData.valTimeType == 1 ? 'monthrange' : 'daterange'" unlink-panels :range-separator="$t('g.to')"
            :start-placeholder="$t('g.start_date')" :end-placeholder="$t('g.end_date')"
            :shortcuts="render.shortcuts2" />
        </div>
        <div class="item">
          <span class="label">{{ $t('openSlotsLit.dev_id') }}</span>
          <el-input class="inp" size="small" v-model="formData.valDevName"
            :placeholder="$t('openSlotsLit.dev_id')"></el-input>
        </div>
        <div class="item">
          <span class="label">{{ $t('openSlotsLit.site_name') }}</span>
          <el-input class="inp" size="small" v-model="formData.valSiteName"
            :placeholder="$t('openSlotsLit.site_name')"></el-input>
        </div>

      </div>
      <div class="btn-ct">
        <el-button @click="func.clear" class="search" type="info">{{ $t('g.clear') }}</el-button>
        <el-button @click="func.exportAllExcel(0)" class="search4" type="info">{{ $t('g.export') }}</el-button>
        <el-button @click="func.search" class="search" type="primary">{{ $t('g.search') }}</el-button>
      </div>
      <div class="line"></div>
      <el-table :data="formData.tableData" :stripe="true" @row-click="func.showDetails" style="width: 100%"
        :summary-method="func.getSummaries" show-summary id="exportTab">
        <el-table-column prop="Id" label="ID" width="80">
        </el-table-column>
        <el-table-column prop="AgentCode" :label="$t('openSlotsLit.agent_code')" width="100">
        </el-table-column>
        <el-table-column prop="SiteName" width="120" :label="$t('openSlotsLit.site_name')">
        </el-table-column>
        <el-table-column prop="DevId" :label="$t('openSlotsLit.dev_id')" width="250">
        </el-table-column>
        <el-table-column prop="ChareDate" :label="formData.valTimeType == 1 ? $t('g.year') : $t('g.year_day')"
          width="120">
        </el-table-column>
        <el-table-column prop="EnergyFee" :label="$t('energy.fee')" width="100">
        </el-table-column>
        <el-table-column prop="EnergyPrice" :label="$t('energy.price')" width="100">
        </el-table-column>
        <el-table-column prop="EnergyNum" :label="$t('energy.num')" width="80">
        </el-table-column>
        <el-table-column prop="CurrEnergyValue" :label="$t('energy.last')" width="110">
        </el-table-column>
        <el-table-column prop="LastEnergyValue" :label="$t('energy.first')" width="110">
        </el-table-column>
        <el-table-column prop="StartAt" :label="$t('activityManage.start_time')" width="180">
        </el-table-column>
        <el-table-column prop="EndAt" :label="$t('activityManage.end_time')" width="180">
        </el-table-column>
        <el-table-column prop="CreatedAtStr" min-width="180" :label="$t('g.create_at')">
        </el-table-column>
      </el-table>
      <div class="pagination">
        <span class="title">{{ $t("g.unit_num") }}:{{ formData.total }}，{{ $t("g.per_page") }}:{{ formData.pageSize
        }}</span>
        <el-pagination background layout="prev, pager, next" @current-change="func.pageChange"
          :page-size="formData.pageSize" :current-page="formData.curPage" :total="formData.total">
        </el-pagination>
      </div>
    </div>
    <el-dialog :title="$t('g.detail')" v-model="formData.dialogDisplayVisible" width="60%" align-center>
      <el-descriptions border column="2">
        <el-descriptions-item label="ID">{{ formData.curData.Id }}</el-descriptions-item>
        <el-descriptions-item :label="$t('openSlotsLit.agent_code')" v-if="!isOperator()">{{ formData.curData.AgentCode
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('openSlotsLit.site_name')">{{ formData.curData.SiteName
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('openSlotsLit.dev_id')">{{ formData.curData.DevId }}</el-descriptions-item>
        <el-descriptions-item :label="$t('device.pattern')">{{ formData.curData.ModeNo }}</el-descriptions-item>
        <el-descriptions-item :label="formData.valTimeType == 1 ? $t('g.year') : $t('g.year_day')">{{
          formData.curData.ChareDate
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('energy.num')">{{ formData.curData.EnergyNum }}</el-descriptions-item>
        <el-descriptions-item :label="$t('energy.price')">{{ formData.curData.EnergyPrice }}</el-descriptions-item>
        <el-descriptions-item :label="$t('energy.fee')">{{ formData.curData.EnergyFee }}</el-descriptions-item>
        <el-descriptions-item :label="$t('energy.last')">{{ formData.curData.CurrEnergyValue }}</el-descriptions-item>
        <el-descriptions-item :label="$t('energy.first')">{{ formData.curData.LastEnergyValue }}</el-descriptions-item>
        <el-descriptions-item :label="$t('activityManage.start_time')">{{ formData.curData.StartAt
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('activityManage.end_time')">{{ formData.curData.EndAt
        }}</el-descriptions-item>
        <el-descriptions-item :label="$t('g.create_at')">{{ formData.curData.CreatedAtStr }}</el-descriptions-item>
      </el-descriptions>
      <template #footer>
        <span class="dialog-footer">
          <el-button type="default" @click="formData.dialogDisplayVisible = false">{{ $t('g.btn_cancel') }}</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { reactive, onMounted, computed } from 'vue'
import { shortcuts, operators, cascade_options_direct } from '@/data/default'
import axios from "axios"
import { toDay } from "@/common/func"
import { user, isOperator } from '@/data/token'
import i18n from '@/data/i18n/index'
import * as XLSX from 'xlsx/xlsx.mjs'
export default {
  name: 'electricityStat',
  components: {
  },
  setup() {
    const t = i18n.global.t
    const tableData = []
    let shortcuts2 = [
      {
        text: '当月',
        value: [new Date(), new Date()],
      },
      {
        text: '当年',
        value: () => {
          const end = new Date()
          const start = new Date(new Date().getFullYear(), 0)
          return [start, end]
        },
      },
      {
        text: '最近6个月',
        value: () => {
          const end = new Date()
          const start = new Date()
          start.setMonth(start.getMonth() - 6)
          return [start, end]
        },
      },
    ]
    const types = [
      {
        label: t('expenses.types.by_month'),
        value: 1
      },
      {
        label: t('expenses.types.by_day'),
        value: 2
      }
    ]
    const render = {
      operators,
      shortcuts,
      shortcuts2,
      cascade_options_direct,
      types
    }
    const formData = reactive({
      tableData,
      slots: {},
      curData: {},
      valTime: '',
      valTypes: -1,
      valTimeType: 1, // 1 按月 2 按天
      valResult: -1,
      dialogVisible: false,
      dialogDisplayVisible: false,
      curPage: 1,
      pageSize: 10,
      total: 0,
      valName: '',
      valCode: 0,
      valDevName: '',
      UpdateAtLast: {},//电池更新最后时间
      props: {
        children: "Children", expandTrigger: 'hover',
        label: "Name",
        value: "CodePath",
        emitPath: false,
        checkStrictly: true
      },
    })
    const func = {
      async exportAllExcel(type = 1) {
        let params = {
        }
        if (formData.valCode) {
          params.AgentCode = formData.valCode
        }
        if (formData.valDevName) {
          params.DevId = formData.valDevName
        }
        if (formData.valSiteName) {
          params.SiteName = formData.valSiteName
        }
        if (formData.valphone) {
          params.Mobile = formData.valphone
        }

        if (formData.valTime) {
          console.log(JSON.stringify(formData.valTime));
          params.sYear = formData.valTime[0].split('-')[0]
          params.sMonth = formData.valTime[0].split('-')[1]
          params.eYear = formData.valTime[1].split('-')[0]
          params.eMonth = formData.valTime[1].split('-')[1]
          if (formData.valTimeType == 2) {
            params.sDay = formData.valTime[0].split('-')[2]
            params.eDay = formData.valTime[1].split('-')[2]
          }
        }
        let url = `/admin/eboxenergyhis/get`
        if (formData.valTimeType == 2) {
          url = `/admin/eboxenergyhis/getDay`
        }
        params.GetAll = 1
        // params.DeviceStatus = formData.valStatus
        if (formData.valTime) {
          params.startAt = Math.floor(Date.parse(formData.valTime[0] + " 00:00:00") / 1000)
          params.endAt = Math.floor(Date.parse(formData.valTime[1] + " 23:59:59") / 1000)
        }
        let loading = ''
        if (params.exportType == 1) {
          loading = ElLoading.service({
            lock: true,
            text: t('openSlotsLit.loading'),
            background: 'rgba(0, 0, 0, 0.7)',
          })
        }

        let res = await axios.get(url, {
          params
        })
        let excleData = [[]];
        let wscols = [];
        excleData = [[
          'ID',
          t('openSlotsLit.agent_code'),
          t('openSlotsLit.site_name'),
          t('openSlotsLit.dev_id'),
          '年月',
          '费用',
          '电价',
          '电量',
          '结束电量记录',
          '开始电量记录',
          '开始时间',
          '结束时间',
          t('g.create_at'),
        ]];
        if (formData.valTimeType == 2) {
          excleData[0][4] = '年月日'
        }
        wscols = [    // 每列不同宽度px
          { wch: 10 },
          { wch: 10 },
          { wch: 20 },
          { wch: 25 },
          { wch: 10 },
          { wch: 12 },
          { wch: 10 },
          { wch: 10 },
          { wch: 12 },
          { wch: 12 },
          { wch: 22 },
          { wch: 22 },
          { wch: 22 },
        ];
        if (res && res.List) {
          for (let item of res.List) {
            let arr = [];
            arr = [
              item.Id,
              item.AgentCode,
              item.SiteName,
              item.DevId,
              item.Year + '-' + item.Month,
              item.EnergyFee,
              item.EnergyPrice,
              item.EnergyNum,
              item.CurrEnergyValue,
              item.LastEnergyValue,
              item.StartAt,
              item.EndAt,
              toDay(item.CreateAt),
            ]
            if (item.Day) {
              arr[4] = item.Year + '-' + item.Month + '-' + item.Day
            }
            excleData.push(arr)
          }
        }

        const worksheet = XLSX.utils.aoa_to_sheet(excleData);
        worksheet["!cols"] = wscols;
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1');
        XLSX.writeFile(workbook, '电费订单' + '.xlsx');
      },
      getSummaries(options) {
        // return
        const { columns, data } = options;
        const sums = [];
        columns.forEach((column, index) => {

          if (index === 1) {
            sums[index] = t("g.total")
            return;
            //index === 22 || index === 24 || index === 28  这是表格第几列需要合计值
            // 例如只需要第3列的值求和，index===3
          } else if (index === 5 || index === 7) {
            let unit = '度'
            switch (index) {
              case 7:
                unit = '度'
                break
              case 5:
                unit = '元'
                break
            }
            let tmp = column.property.split('.');
            const values = data.map((item) => Number(item[tmp[0]]));
            sums[index] = values.reduce((prev, curr) => {
              const value = Number(curr);
              if (!isNaN(value)) {
                return Math.floor((prev + curr) * 100) / 100;
              } else {
                return prev;
              }
            }, 0) + unit;
          }
        });
        return sums;
      },
      showDetails(row) {
        formData.dialogDisplayVisible = true;
        formData.curData = row;
      },
      search() {
        func.loadData()
      },
      clear() {
        formData.valCode = '';
        formData.valDevName = '';
        formData.valphone = '';
        formData.valSiteName = '';
        formData.valTime = '';
        func.loadData()
      },
      rowDblClick(row, column, e) {
        formData.curData = row
        formData.dialogVisible = true
      },
      pageChange(val) {
        func.loadData(val)
      },
      showAddDataDialog() {
        formData.curData = {
        }
        formData.dialogVisible = true
      },
      async loadData(page = 1) {
        try {
          formData.tableData = []
          formData.curPage = page
          let params = {
            page,
          }
          let url = `/admin/eboxenergyhis/get`
          if (formData.valCode) {
            params.AgentCode = formData.valCode
          }
          if (formData.valDevName) {
            params.DevId = formData.valDevName
          }
          if (formData.valSiteName) {
            params.SiteName = formData.valSiteName
          }
          if (formData.valphone) {
            params.Mobile = formData.valphone
          }
          console.log(JSON.stringify(formData.valTime));
          if (formData.valTime) {

            params.sYear = formData.valTime[0].split('-')[0]
            params.sMonth = formData.valTime[0].split('-')[1]
            params.eYear = formData.valTime[1].split('-')[0]
            params.eMonth = formData.valTime[1].split('-')[1]
            if (formData.valTimeType == 2) {
              params.sDay = formData.valTime[0].split('-')[2]
              params.eDay = formData.valTime[1].split('-')[2]
            }

          }

          if (formData.valTimeType == 2) {
            url = `/admin/eboxenergyhis/getDay`
          }
          let res = await axios.get(url, {
            params
          })
          formData.total = res.Total
          res.List.map((item) => {
            item.CreatedAtStr = toDay(item.CreateAt)
            if (item.Day) {
              item.ChareDate = item.Year + '-' + item.Month + '-' + item.Day
            } else {
              item.ChareDate = item.Year + '-' + item.Month
            }
          })
          formData.tableData = res.List
          formData.pageSize = res.PageSize
        } catch (e) {
          console.log("loadData", e)
        }
      }
    }
    onMounted(() => {
      func.loadData()
    })
    return {
      func,
      render,
      formData,
      token: user.token,
      isOperator,
    }
  }
}
</script>

<style lang="scss" scoped>
.content {
  box-sizing: border-box;
  padding: 1.25rem;

  .table-detail {
    display: flex;
    flex-direction: column;
    margin-right: 3rem;
    padding-left: 2rem;
    // background-color: grey;

    // padding-top: 1rem;

    .slots {
      margin-top: 1rem;

      .slot {
        display: flex;
        margin-bottom: 0.5rem;

        >div {
          width: 8rem;

          &:first-child {
            width: 6rem;
          }
        }


      }
    }

    >.item {
      margin-right: 0.625rem;
      display: flex;
      align-items: center;
      margin-bottom: 0.625rem;
      color: #333333;

      >img {
        margin-left: 0.625rem;
        width: 4rem;
        height: 3rem;
        object-fit: cover;
      }
    }
  }

  .boximg {
    width: 4rem;
    height: 3rem;
    object-fit: cover;
  }

  >.card-box {
    font-size: 0.875rem;
    background-color: #fff;
    box-shadow: $box-shadow;
    box-sizing: border-box;
    padding: 1.25rem;
    border-radius: 0.3rem;
    // margin-bottom: 1.25rem;

    .header {
      text-align: left;
      margin-bottom: 1.25rem;
      position: relative;

      >.title {
        font-size: 1rem;
        font-weight: 500;
      }

      >.header-icons {
        position: absolute;
        right: 10px;
        top: 0px;
        z-index: 100;

        .header-icon {
          font-size: 0.875rem;
          font-weight: 500;
          border: 1px solid #ddd;
          color: #969696;
          padding: 0.25rem;
          border-radius: 50%;
          color: pointer;
          margin-left: 0.625rem;
          cursor: pointer;
        }
      }
    }

    >.btn-ct {
      text-align: right;

      :deep(.el-button--small) {
        padding: 0.625rem 2rem;
      }
    }

    .inp-list {
      display: grid;
      margin: 0 auto;
      margin-top: 1rem;
      grid-template-columns: repeat(4, 24.1%);
      gap: 14px 16px;

      >.item {
        display: flex;
        align-items: left;


        .label {
          display: flex;
          justify-content: left;
          min-width: 76px;
        }

        :deep(.el-range-editor--small.el-input__inner) {
          flex: 1;
        }

        .inp {
          flex: 1;
        }
      }
    }
  }

  >.el-alert-my {
    margin-bottom: 1.25rem;
    box-shadow: $box-shadow;
    padding: 1.25rem;

    .el-alert-my-txt {
      font-size: 0.875rem;

      >.tips {
        font-weight: bold;
      }
    }

    :deep(.el-alert__closebtn) {
      top: 1.25rem;
      font-size: 1rem;
    }
  }

  >.data-table {
    :deep(.el-table) {
      .cell {
        white-space: nowrap;
        text-overflow: ellipsis;
      }

      .el-table__row {
        cursor: pointer;
      }
    }
  }

  >.pagination {
    text-align: right;
    margin-top: 1.25rem;
  }

  .el-form-row {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    :deep(.el-form-item) {
      width: 49%;
    }

    &.line-3 {
      :deep(.el-form-item) {
        min-width: 32%;
      }
    }

    .inp {
      width: 100%;
    }

    .avatar-uploader {
      :deep(.el-upload) {
        border: 1px dashed #d9d9d9;
        border-radius: 0.375rem;
        cursor: pointer;
        position: relative;
        overflow: hidden;

        &:hover {
          border-color: #409eff;
        }
      }
    }

    .avatar-uploader-icon {
      font-size: 1.75rem;
      color: #8c939d;
      width: 11rem;
      height: 9rem;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    .avatar {
      width: 11rem;
      height: 9rem;
      display: block;
      object-fit: cover;
    }
  }

  .el-select-my {
    text-align: left;
    display: block;
  }

  :deep(.m-dialog) {
    max-width: 70rem;
    // width:70vw;
  }
}

@media screen and (max-width:800px) {
  .content {
    >.card-box {
      .inp-list {
        >.item {
          width: 100%;
        }
      }
    }
  }
}
</style>